import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { I18nModule } from '@recruitee/i18n';
import { ButtonComponent, HeadingComponent, IconComponent } from '@recruitee/user-interface';

import { RtoNotFoundComponent } from './not-found/not-found.component';
import { OnboardingRouteReuseStrategy } from './onboarding.route-reuse-strategy';
import { OnboardingI18nResolver } from './shared/onboarding-i18n-resolver.service';
import { OnboardingSharedModule } from './shared/shared.module';

@NgModule({
  declarations: [RtoNotFoundComponent],
  providers: [{ provide: RouteReuseStrategy, useClass: OnboardingRouteReuseStrategy }],
  imports: [
    RouterModule.forRoot(
      [
        {
          path: ':lang',
          resolve: [OnboardingI18nResolver],
          children: [
            {
              path: ':token/company',
              loadChildren: () =>
                import('./company/company.module').then(m => m.OnboardingCompanyModule),
            },
            {
              path: ':token/user',
              loadChildren: () => import('./user/user.module').then(m => m.OnboardingUserModule),
            },
            { path: '404', component: RtoNotFoundComponent },
            { path: '**', redirectTo: '404', pathMatch: 'full' },
          ],
        },
        { path: '**', redirectTo: 'en/404', pathMatch: 'full' },
      ],
      {
        paramsInheritanceStrategy: 'always',
      },
    ),
    I18nModule,
    OnboardingSharedModule,
    HeadingComponent,
    IconComponent,
    ButtonComponent,
  ],
  exports: [RouterModule],
})
export class RtoAppRoutingModule {}
